<template>
  <div class="AdminHeaderWrap">
    <div class="AdminHeaderInner"
     :class="adminMenuData.menuOpenStatus ? '' : 'display_none'">
      <button class="AdminHeader_menuClose" v-on:click="menu_change">
      </button>

      <div class="Admin_Sidemenu">
        <div class="Admin_Sidemenu_MainTit">
          <a href="#" @click.prevent="resetActiveMenu">
              (주)행복을주는사람들
          </a>
        </div>

        <!-- 시스템 관리 -->
        <div :class="permissionData.permissionArray.includes('1') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('systemManagement')">
            시스템 관리<span class="menu-arrow">{{ menuToggleState.systemManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.systemManagement">
            <p :class="[getSubMenuClass('1-1'), permissionData.permissionArray.includes('1-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-1', '/AdminMenuPermissionManagement')">
                메뉴권한 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('1-2'), permissionData.permissionArray.includes('1-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-2', '/AdminManagement')">
                사용자 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('1-3'), permissionData.permissionArray.includes('1-3') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-3', '/AdminHotKeywordManagement')">
                HOT 키워드 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('1-6'), permissionData.permissionArray.includes('1-6') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-6', '/AdminMessageLogManagement')">
                메세지 로그
              </a>
            </p>
            <p :class="[getSubMenuClass('1-7'), permissionData.permissionArray.includes('1-7') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-7', '/AdminPointLogManagement')">
                포인트 로그
              </a>
            </p>
            <p :class="[getSubMenuClass('1-8'), permissionData.permissionArray.includes('1-8') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-8', '/AdminPopupManagement')">
                팝업 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('1-9'), permissionData.permissionArray.includes('1-9') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-9', '/AdminSendMessage')">
                문자 발송
              </a>
            </p>
            <p :class="[getSubMenuClass('1-10'), permissionData.permissionArray.includes('1-10') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-10', '/AdminBenefitsManagement')">
                혜택 관리
              </a>
            </p>
          </div>
        </div>

        <!-- 회원 관리 -->
        <div :class="permissionData.permissionArray.includes('2') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('customerManagement')">
            회원 관리<span class="menu-arrow">{{ menuToggleState.customerManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.customerManagement">
            <p :class="[getSubMenuClass('2-1'), permissionData.permissionArray.includes('2-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-1', '/AdminCustomerManagement')">
                회원 현황
              </a>
            </p>
          </div>
        </div>

        <!-- 메뉴 관리 -->
        <div :class="permissionData.permissionArray.includes('5') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('menuManagement')">
            메뉴 관리<span class="menu-arrow">{{ menuToggleState.menuManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.menuManagement">
            <p :class="[getSubMenuClass('5-1'), permissionData.permissionArray.includes('5-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('5-1', '/AdminPerformanceManagement')">
                공연 관리
              </a>
            </p>
          </div>
        </div>

        <!-- 푸터 관리 -->
        <div :class="permissionData.permissionArray.includes('7') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('footerManagement')">
            푸터 관리<span class="menu-arrow">{{ menuToggleState.footerManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.footerManagement">
            <p :class="[getSubMenuClass('7-1'), permissionData.permissionArray.includes('7-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('7-1', '/AdminPartnerManagement')">
                협력업체 관리
              </a>
            </p>
          </div>
        </div>

        <!-- 메인화면 관리 -->
        <div :class="permissionData.permissionArray.includes('3') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('mainManagement')">
            메인화면 관리<span class="menu-arrow">{{ menuToggleState.mainManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.mainManagement">
            <p :class="[getSubMenuClass('3-1'), permissionData.permissionArray.includes('3-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-1', '/AdminRollingBannerManagement')">롤링 배너 관리</a>
            </p>
            <p :class="[getSubMenuClass('3-2'), permissionData.permissionArray.includes('3-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-2', '/AdminRecommendBannerManagement')">추천여행 배너 관리</a>
            </p>
            <p :class="[getSubMenuClass('3-3'), permissionData.permissionArray.includes('3-3') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-3', '/AdminRecommendMonthBannerManagement')">이달의 추천여행 배너 관리</a>
            </p>
            <p :class="[getSubMenuClass('3-4'), permissionData.permissionArray.includes('3-4') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-4', '/AdminFixBannerManagement')">고정 배너 관리</a>
            </p>
          </div>
        </div>

        <div :class="permissionData.permissionArray.includes('8') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('communityManagement')">
            커뮤니티 관리<span class="menu-arrow">{{ menuToggleState.communityManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.communityManagement">
            <p :class="[getSubMenuClass('8-1'), permissionData.permissionArray.includes('8-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('8-1', '/AdminNoticeManagement')">공지사항 관리</a>
            </p>
            <p :class="[getSubMenuClass('8-2'), permissionData.permissionArray.includes('8-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('8-2', '/AdminTravelReviewManagement')">여행후기 관리</a>
            </p>
            <p :class="[getSubMenuClass('8-3'), permissionData.permissionArray.includes('8-3') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('8-3', '/AdminOnlineInquiryManagement')">온라인문의 관리</a>
            </p>
            <p :class="[getSubMenuClass('8-4'), permissionData.permissionArray.includes('8-4') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('8-4', '/AdminFrequentlyQuestionsManagement')">자주 묻는 질문 관리</a>
            </p>
            <p :class="[getSubMenuClass('8-5'), permissionData.permissionArray.includes('8-5') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('8-5', '/AdminGroupInquiryManagement')">단체여행 문의 관리</a>
            </p>
          </div>
        </div>

        <!-- 여행 관리 -->
        <div :class="permissionData.permissionArray.includes('4') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('travelManagement')">
            여행 관리<span class="menu-arrow">{{ menuToggleState.travelManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.travelManagement">
            <p :class="[getSubMenuClass('4-1'), permissionData.permissionArray.includes('4-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('4-1', '/AdminTravelTypeManagement')">여행타입 관리</a>
            </p>
            <p :class="[getSubMenuClass('4-2'), permissionData.permissionArray.includes('4-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('4-2', '/AdminTravelProductManagement')">여행상품 관리</a>
            </p>
            <p :class="[getSubMenuClass('4-3'), permissionData.permissionArray.includes('4-3') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('4-3', '/AdminScheduleManagement')">여행일정 관리</a>
            </p>
            <p :class="[getSubMenuClass('4-4'), permissionData.permissionArray.includes('4-4') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('4-4', '/AdminTmsManagement')">여행관리 시스템(TMS)</a>
            </p>
          </div>
        </div>

        <!-- 결제/예약 관리 -->
        <div :class="permissionData.permissionArray.includes('6') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('reservationManagement')">
            결제 관리<span class="menu-arrow">{{ menuToggleState.reservationManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.reservationManagement">
            <p :class="[getSubMenuClass('6-1'), permissionData.permissionArray.includes('6-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('6-1', '/AdminReservationManagement')">결제 현황</a>
            </p>
            <p :class="[getSubMenuClass('6-2'), permissionData.permissionArray.includes('6-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('6-2', '/AdminImmediatePaymentManagement')">바로결제 관리</a>
            </p>
          </div>
        </div>

      </div>
    </div>

    <div :class="adminMenuData.menuOpenStatus ? 'display_none' : ''">
      <button class="AdminHeader_menuOpen" v-on:click="menu_change">
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import {
  get_session_admin
} from '../../ETC/Axios.vue'
import { ref } from 'vue'

export default {
  name: 'AdminHeader',
  props: ['menu_id', 'menu_check'],
  setup () {
    const getToggleState = () => {
      const savedState = localStorage.getItem('menuToggleState')
      return savedState ? JSON.parse(savedState) : {
        systemManagement: false,
        customerManagement: false,
        menuManagement: false,
        footerManagement: false,
        mainManagement: false,
        communityManagement: false,
        travelManagement: false,
        reservationManagement: false
      }
    }
    const getMenuOpenStatus = () => {
      const savedStatus = localStorage.getItem('menuOpenStatus')
      return savedStatus ? JSON.parse(savedStatus) : true
    }
    const getActiveMenu = () => {
      return localStorage.getItem('activeMenu') || ''
    }
    return {
      sessionData: ref({
        customer: {}
      }),
      permissionData: ref({
        permissionArray: []
      }),
      adminMenuData: ref({
        menuOpenStatus: getMenuOpenStatus()
      }),
      menuToggleState: ref(getToggleState()),
      activeMenu: ref(getActiveMenu())
    }
  },
  methods: {
    resetActiveMenu () {
      localStorage.setItem('activeMenu', '')
      this.activeMenu = ''
      this.$router.push('/AdminMain')
    },
    menu_change () {
      this.adminMenuData.menuOpenStatus = !this.adminMenuData.menuOpenStatus
      localStorage.setItem('menuOpenStatus', JSON.stringify(this.adminMenuData.menuOpenStatus))
    },
    toggleMenu (menuKey) {
      this.menuToggleState[menuKey] = !this.menuToggleState[menuKey]
      localStorage.setItem('menuToggleState', JSON.stringify(this.menuToggleState))
    },
    setActiveMenu (menuId, path) {
      if (this.$route.path !== path) {
        localStorage.setItem('activeMenu', menuId)
        this.activeMenu = menuId
        this.$router.push(path)
      }
    },
    getSubMenuClass (menuKey) {
      return this.activeMenu === menuKey ? 'Admin_Sidemenu_SubTit menu_active' : 'Admin_Sidemenu_SubTit'
    }
  },
  mounted () {
    get_session_admin().then(result => {
      if (result === '') {
        alert('로그인 유지시간이 만료되었습니다.')
        window.location.href = '/AdminLogin'
      } else if (
        !result.menu_permission_array.includes(this.menu_id) &&
        this.menu_check !== false
      ) {
        alert('해당메뉴에 권한이 없습니다.')
        window.location.href = '/AdminMain'
      } else {
        this.sessionData.customer = result
        this.permissionData.permissionArray = JSON.parse(this.sessionData.customer.menu_permission_array)
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Section/AdminHeader.vue